import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const redirect = new URLSearchParams(loc.search).get("redirect");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (!res.ok) { toast.error(res.error); return; }
    toast.success(`Welcome back, ${res.user.name}!`);
    if (redirect) nav(redirect);
    else if (["admin", "manager", "cashier"].includes(res.user.role)) nav("/admin");
    else if (res.user.role === "driver") nav("/driver");
    else nav("/");
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 sm:px-6 py-8 sm:py-12 page-enter">
      <div className="w-full max-w-md bg-white border border-[#E1E5DF] rounded-2xl p-6 sm:p-8 shadow-[0_10px_40px_rgba(0,0,0,0.05)]">
        <div className="flex justify-center mb-4">
          <img src="/assets/arbe-logo.png" alt="Arbe" className="h-14 w-14 object-contain" />
        </div>
        <h1 className="font-heading text-3xl font-extrabold text-[#1C2826] text-center tracking-tighter">Welcome back</h1>
        <p className="text-center text-[#4A5D5A] mt-1 text-sm">Log in to place orders, manage the store or start deliveries.</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label>Email</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-11" required data-testid="login-email" />
          </div>
          <div>
            <Label>Password</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-11" required data-testid="login-password" />
          </div>
          <Button disabled={loading} type="submit" className="w-full h-11 bg-[#2F5233] hover:bg-[#1F3D24] text-white rounded-full font-semibold" data-testid="login-submit">
            {loading ? "Logging in..." : "Log in"}
          </Button>
        </form>
        <div className="mt-5 text-center text-sm text-[#4A5D5A]">
          No account? <Link to="/register" className="text-[#2F5233] font-medium hover:underline" data-testid="go-register">Create one</Link>
        </div>
      </div>
    </div>
  );
}
